<p>paged-resource-list works!</p>
